<script>
import {mapGetters} from 'vuex'
export default {

    name: 'confirm-modal',

    props:
    {
        withRedirect: Boolean,
        type: String,
    },

    computed:
    {
        ...mapGetters({
            offerRedirectTo: 'offerRedirectTo',
            landingPageRedirectTo: 'landingPageRedirectTo'
        }),
    },

    methods: {
        cancel()
        {
            this.$refs.confirmModal.close()
        },
        openModal()
        {
            this.$refs.confirmModal.open()
        },
        setDirty()
        {
            this.$store.dispatch(this.type,false)
            this.cancel()
            if (this.withRedirect) {
                const params = this.type == 'landingPageFormDirty' ? this.landingPageRedirectTo : this.offerRedirectTo
                this.$router.push({
                    name: params.name,
                    params: params.params
                })
            } else {
                this.$emit('yes')
            }
        },
    }

}
</script>

<template lang="html">
    <custom-modal ref="confirmModal">
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Are you Sure?
            </p>
        </div>
        <div>
            <p class="text-lg font-weight-bold">
                You have unsaved changes
            </p>
        </div>
        <div slot="footer" class="">
            <custom-button classes="white w-120" text="No" @buttonClick="cancel"></custom-button>
            <custom-button classes="w-120 blue text-white" text="Yes" @buttonClick="setDirty"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/confirm.vue